class Btn_Compare {
	constructor() {
		this.selectors = {
			document: document,
			add_Compare: '.js-add-compare',
			removeCompare: '.js-remove-compare',
			goToComparePage: '.js-to-compare-page',
			clearCompareList: '.js-clean-compare-btn',
			compareCategories: '.compare_category_list'
		};
		this.init();
		this.events();
	};
	init() {
		var self = this;
		this.getNodes();

		const value = self.getStorage('compare_products');

		let count = 0;
		if (value) {
			var added_ids = value.split('+');
			count = value.split('+').length
			const href = self.nodes.goToComparePage.data('href');
			self.nodes.goToComparePage.attr('href', href+value + '/' );
		}
		const href = self.nodes.goToComparePage.data('href');
		$('.js-compare-mobile').find('.js-compare-mobile-count').text(count);
		$('.js-compare').find('.js-compare-count').text(count);
		this.nodes.add_Compare.each( function(e){
			var $this = $(this);
			var add_id = $this.data('id');			
			if (added_ids){
				for (let i = 0; i < added_ids.length; i++){
					if(add_id == added_ids[i]){
						$this.addClass('active-btn');
					}
				}
			}
		});
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {

		var self = this;

		// Button adds product to Compare List

		self.nodes.compareCategories.on('click', 'a', function(e){
			e.preventDefault();
			let cat_id = $(e.currentTarget).data('id')
			const urlPath = window.location.pathname.split('/');
			let url = urlPath[0]+'/'+urlPath[1]+'/'+urlPath[2]+'/'+urlPath[3]+'/'+urlPath[4];
			url = url + '/' + cat_id;
			location.assign(url);
		});
		this.nodes.document.on('click', this.selectors.add_Compare, (e) => {
			e.preventDefault();
			var $this = $(e.currentTarget);
			var id = $this.data('id');
			var url = $this.attr('href');
			var $this = $(e.currentTarget);
			if ($(window).width() < 1200) {
				var compareIcon = $('.js-compare-mobile');
			} else {
				var compareIcon = $('.js-compare');
			}
			var compare_icon = $('.js-compare');
			var compare_mobile_icon = $('.js-compare-mobile');
			var total_count_compare = compare_icon.find('.js-compare-count');
			var total_count_compare_mobile = compare_mobile_icon.find('.js-compare-mobile-count');

			var imgToDrag = ( $this.data('main') == 'yes' ) ? $(document).find(".js-product-slider .slick-current img").eq(0)
				: $this.closest('.js-content').find("img:not(.brand_img, .moldova_img)").eq(0);
			self.setStorage('compare_products', id, $this);
			if ( !$this.hasClass('active-btn')) {
//				if (imgToDrag.length) {
//					var imgClone = imgToDrag.clone()
//					.offset({
//						top: imgToDrag.offset().top,
//						left: imgToDrag.offset().left
//					})
//					.css({
//						'opacity': '0.5',
//						'position': 'absolute',
//						'height': '150px',
//						'max-width': '150px',
//						'z-index': '100',
//						'bottom': 'unset',
//						'right': 'unset'
//					})
//					.appendTo($('body'))
//					.animate({
//						'top': compareIcon.offset().top + 10,
//						'left': compareIcon.offset().left + 10,
//						'max-width': 75,
//						'height': 75
//					}, 1000, 'easeInOutExpo');
//
//					imgClone.animate({
//						'width': 0,
//						'height': 0
//					});
//
//					setTimeout(function () {
//						compareIcon.addClass('pulse');
//					}, 1500);
//					setTimeout(function () {
//						compareIcon.removeClass('pulse');
//					}, 2000);
//				}

			} else {
				if (window.location.pathname.indexOf('compare') != -1){
					const pathname = window.location.pathname; // Returns path only
					const urlPath = pathname.split('/');
					let url = urlPath[0]+'/'+urlPath[1]+'/'+urlPath[2];
					const ids = urlPath[3].split('+');
					var i = ids.indexOf(id.toString());
					if(i != -1) {
						ids.splice(i, 1);
						url += '/'+ids.join('+');
						url += '/'+urlPath[4];
						location.assign(url);
					}
				}

			}
			var products = self.getStorage('compare_products');
			if (products){
				var i = products.indexOf(id);
				if ( i == -1 ){
					$this.removeClass('active-btn');
					total_count_compare.text(parseInt(parseInt(total_count_compare.text()) - 1));
					total_count_compare_mobile.text(parseInt(parseInt(total_count_compare_mobile.text()) - 1));
				} else {
					$this.addClass('active-btn')
					total_count_compare.html(parseInt(total_count_compare.text()) + 1);
					total_count_compare_mobile.html(parseInt(total_count_compare_mobile.text()) + 1);

				}
			} else {
				if ( $this.hasClass('active-btn')) {
					products = '';
					$this.removeClass('active-btn');
					total_count_compare.text(parseInt(total_count_compare.text()) - 1);
					total_count_compare_mobile.text(parseInt(total_count_compare_mobile.text()) - 1);
				} else {
					products = id;
					$this.addClass('active-btn')
					total_count_compare.html(parseInt(total_count_compare.text()) + 1);
					total_count_compare_mobile.html(parseInt(total_count_compare_mobile.text()) + 1);
				}
			}

			$.ajax(url, {
				method: "POST",
				data: {ids: products},
				success: function (result) {}
			});
		});

		this.nodes.document.on('click', this.selectors.removeCompare, (e) => {
			e.preventDefault();
			var $this = $(e.currentTarget);
			const id = $this.data('id').toString();
			const pathname = window.location.pathname; // Returns path only
			const urlPath = pathname.split('/');
			const urlPath_length = urlPath.length;
			let url = urlPath[0]+'/'+urlPath[1]+'/'+urlPath[2]+'/'+urlPath[3];
			const ids = urlPath[4].split('+');
			var i = ids.indexOf(id);
			const count = self.nodes.compareCategories.find('li.active').data('count')
			// console.log('count = '+count);
			if(i != -1) {
				ids.splice(i, 1);
				url += '/'+ids.join('+');
				if (count > 1 && urlPath_length == 6){
					url += '/'+urlPath[5];
					// console.log('url = '+url);
					// console.log('urlPath[5] = '+urlPath[5]);
				}
				location.assign(url);

			}
			location.assign(url);
			// console.log('url = '+url);
			self.setStorage('compare_products', id, null);
		});

		this.nodes.clearCompareList.on('click', function(e){
			window.localStorage.clear('compare_products');
			$('.js-compare-mobile').find('.js-compare-mobile-count').text(0);
			$('.js-compare').find('.js-compare-count').text(0);
			setTimeout(function(){
				$('.js-clean-compare-btn').hide();
				$('.empty_list').removeClass('d-none');
			}, 2000);
		});
	}

	setStorage(cname, cvalue, current=null) {
		var self = this;
		let value = cvalue;
		const ids = self.getStorage('compare_products') ? self.getStorage('compare_products').split('+') : [];
		var i = ids.indexOf(value.toString());
		if (i != -1 ) {
			ids.splice(i, 1);
		} else {
			ids.unshift(value);
		}
		while ( ids.length > 15 )
			ids.pop()
		value = ids.join('+');
		value.toString()
		const href = self.nodes.goToComparePage.data('href');
		self.nodes.goToComparePage.attr('href', href+value + '/');
		window.localStorage.setItem(cname, value.toString() )

	}

	getStorage(cname) {
		return window.localStorage.getItem(cname);
	}
}
new Btn_Compare();
